import * as React from 'react';
import * as styles from './SubwayColor.css';

interface ISubwayColorProps {
  color: string;
}

export function SubwayColor({ color }: ISubwayColorProps) {
  return <mark className={styles['subway-color']} style={{ backgroundColor: `#${color}` }} />;
}
